export function fmt(n, decimals = 2) {
  if (n == null || n === '') return '—';
  const num = parseFloat(n);
  if (isNaN(num)) return '—';
  return num.toLocaleString('en-IN', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function fmtDate(d) {
  if (!d) return '—';
  try {
    const dt = new Date(d);
    if (isNaN(dt)) return String(d);
    return dt.toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' });
  } catch { return String(d); }
}

export function extractCategory(message, fallback = '—') {
  if (!message) return fallback;
  const m = message.match(/^([\w][\w\s]*?)\s+ledger\s+"/i);
  return m ? m[1].trim() : fallback;
}

export function voucherRef(issue) {
  if (issue.voucher_ref && issue.voucher_ref !== 'null') return issue.voucher_ref;
  if (issue.voucher     && issue.voucher     !== 'null') return issue.voucher;
  if (issue.raw_voucher_type && issue.voucher_number)
    return `${issue.raw_voucher_type} #${issue.voucher_number}`;
  return null;
}
